import React from 'react';
import AboutHero from './about/AboutHero';
import Mission from './about/Mission';
import Values from './about/Values';
import Team from './Team';
import BackgroundComposer from './background/BackgroundComposer';

const About = () => {
  return (
    <section id="about" className="relative overflow-hidden bg-[#141414]">
      <BackgroundComposer intensity="low">
        <div className="container mx-auto px-4">
          <div className="space-y-16 max-w-6xl mx-auto text-white/90">
            <AboutHero />
            <Mission />
            <Values />
            <Team />
          </div>
        </div>
      </BackgroundComposer>
    </section>
  );
};

export default About;